/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCloneEditVideoEditorEditsMutationRequest, WebAppCloneEditVideoEditorEditsMutationResponse, WebAppCloneEditVideoEditorEditsPathParams } from "../models/WebAppCloneEditVideoEditorEdits";

export function getWebAppCloneEditVideoEditorEditsUrl(id: WebAppCloneEditVideoEditorEditsPathParams["id"]) {
  const res = { method: 'POST', url: `/web-app/video-editor/edits/${id}/clone` as const }
  return res
}

/**
 * @summary Clone an edit (requires new name); response includes creator and published platforms
 * {@link /web-app/video-editor/edits/:id/clone}
 */
export async function webAppCloneEditVideoEditorEdits(id: WebAppCloneEditVideoEditorEditsPathParams["id"], data: WebAppCloneEditVideoEditorEditsMutationRequest, config: Partial<RequestConfig<WebAppCloneEditVideoEditorEditsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppCloneEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, WebAppCloneEditVideoEditorEditsMutationRequest>({ method : "POST", url : getWebAppCloneEditVideoEditorEditsUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}